
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careerDemographicsPage",
      function () {
        return require("private-next-pages/careerDemographicsPage.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/careerDemographicsPage"])
      });
    }
  